import { Component, OnInit } from '@angular/core';
import { tick } from '@angular/core/testing';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MSSPService } from 'src/app/services/mssp.service';

@Component({
  selector: 'app-find-by-ticket',
  templateUrl: './find-by-ticket.component.html',
  styleUrls: ['./find-by-ticket.component.scss']
})
export class FindByTicketComponent implements OnInit {

  ticketForm = new FormGroup({
    ticket: new FormControl('',[Validators.required] )
  })
  
  constructor(
    private msspService: MSSPService,
    private router: Router) { }

  ngOnInit(): void {
  }

  validateTicket(){
    if(this.ticketForm.valid){
      const ticket = this.ticketForm.controls['ticket'].value;
      this.getLink(ticket);
    }
  }

  formatTicket(ticket:string):string{
    let splitTicket = ticket.split('');
    splitTicket.splice(4,0,'0');
    splitTicket.splice(8,0,'0');1
    let formatedTicket = splitTicket.join('');
    return formatedTicket;
  }

  getLink(ticket:string){
    const data = {
      sessionId: "",
      poliza: "nuevaPoliza",
      certificado: ticket,
      dealerCode: "EA113",
      RFC: "A"
    }

    this.msspService.generateLink(data).subscribe({
      next: ((response:any) => {
        window.location.href = response.url;
        // const url = response.url.replace('https://localhost:4210/?q=', '');
        // this.router.navigate(['pif',{q:url}]);
      }),
      error:( error =>{
        console.log(error);
      })
    })
  }
}
